import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import Actions from '../redux/actions/index';
import { isValidEmail, isValidPassword } from '../utils/validation';
import RoutePath from '../utils/routes/RoutePath';
import AppLoader from '../utils/AppLoader';
import Constants from '../utils/Constants';
import { toast } from 'react-toastify';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import loginLogo from '../../src/assets/img/Live_Agent_Logo.svg';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { persistVendorDefaultVideoFlags } from '../utils/vendorDefaultVideo';
class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            empId: '',
            error: {},
            message: {},
            isAdmin: false,
            isVendor: false,
            validEmail: true,
            validPassword: true,
            showPassword: false,
            requiresEmpId: false,
        };
    }


    componentDidMount() {
        if (this.props.location.pathname === RoutePath.ADMIN_LOGIN_SCREEN_PATH) {
            this.setState({ isAdmin: true, isVendor: false });
            const { getLoginDetails } = this.props;
            if ((getLoginDetails?.adminTokenDetails?.access_token ?? false) && localStorage.length > 0) {
                this.props.history.push('/admin/dashboard');
            }
        } else if (this.props.location.pathname === RoutePath.VENDOR_LOGIN_SCREEN_PATH) {
            this.setState({ isVendor: true, isAdmin: false });
            const { getLoginDetails } = this.props;
            if ((getLoginDetails?.vendorTokenDetails?.access_token ?? false) && localStorage.length > 0) {
                if (getLoginDetails?.vendorTokenDetails?.userDetails?.Vendor?.isFeedback) {
                    this.props.history.push(RoutePath.VENDOR_FEEDBACK);
                } else {
                    this.props.history.push('/vendor/dashboard');
                }
            }
        } else if (this.props.location.pathname === RoutePath.LOGIN_SCREEN_PATH && localStorage.length > 0) {
            const { getLoginDetails } = this.props;
            if ((getLoginDetails?.tokenDetails?.access_token ?? false) && localStorage.length > 0) {
                this.props.history.push('/store');
            }
        }
    }

    submitHandler = () => {
        this.setState({ isLoading: true });
        const { email, password, empId, isAdmin, isVendor, error, message, requiresEmpId } = this.state;
        if (!requiresEmpId) {
            if (!email) {
                this.setState({ isLoading: false, error: { isEmailId: true }, message: { isEmailId: Constants.PLEASE_ENTER_EMAIL } });
                return;
            } else if (!isValidEmail(email)) {
                this.setState({ isLoading: false, error: { isEmailId: true }, message: { isEmailId: Constants.INVALID_EMAIL_ID } });
                return;
            }
        } else if (!empId?.trim()) {
            this.setState({ isLoading: false, error: { isEmpId: true }, message: { isEmpId: Constants.EMPLOYEE_ID_REQUIRED } });
            return;
        }

        this.setState({ validEmail: false });
        const params = {
            grant_type: "password",
            username: email,
            password: password,
            scope: isAdmin ? "super_admin" : isVendor ? "vendor_admin" : "agent",
            roleId: isAdmin ? 1 : isVendor ? 2 : 3,
            ...(requiresEmpId ? { empId: empId.trim() } : {}),
        };
        const logincallback = (response) => {
            if (response.response_code === 0) {
                if (response?.response?.requiresEmpId && !requiresEmpId) {
                    this.setState({ isLoading: false, requiresEmpId: true });
                    return;
                }
                if (!response?.response?.access_token) {
                    this.setState({ isLoading: false });
                    return;
                }
                this.setState({ isLoading: false, requiresEmpId: false });
                switch (response?.response?.user?.roleId) {
                    case 1:
                        this.props.history.push(RoutePath.ADMIN_DASHBOARD_SCREEN);
                        break;
                    case 2:
                        if (response?.response?.userDetails?.Vendor?.isFeedback) {
                            this.props.history.push(RoutePath.VENDOR_FEEDBACK);
                        } else {
                            this.props.history.push(RoutePath.VENDOR_DASHBOARD_SCREEN);
                        }
                        break;
                    case 3:
                        // Same as mobile nurse login: apply Vendor defaultVideoOnNurse / Patient
                        persistVendorDefaultVideoFlags(
                            response?.response?.userDetails?.VendorAgent?.Vendor || {}
                        );
                        localStorage.setItem('companyName', response?.response?.userDetails?.VendorAgent?.Vendor?.companyName);
                        this.props.history.push(RoutePath.STOREMANAGER_SCREEN_PATH);
                        break;
                    default:
                        break;
                }
            } else {
                this.setState({ isLoading: false });
                toast.error(response?.response_message, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        };
        this.props.login(params, logincallback, isAdmin, isVendor);
    };
    forgetPassword() {
        const params = {
            grant_type: "client_credentials",
            scope: "public"
        };
        const forgetPasswordCallback = (response) => {
            if (response.response_message === "success") {
                this.props.history.push(RoutePath.FORGET_PASSWORD);
            }
        };
        this.props.forgetpassword(params, forgetPasswordCallback);

    }
    handleEmail = (event) => {
        this.setState({ email: event.target.value });
        let email = event.target.value;
        if (email.length === 0) {
            this.setState({ error: { isEmailId: true }, message: { isEmailId: Constants.PLEASE_ENTER_EMAIL } });
            this.setState({ validEmail: true });
            return false;
        }
        else if (!isValidEmail(email)) {
            this.setState({ error: { isEmailId: true }, message: { isEmailId: Constants.INVALID_EMAIL_ID } });
            this.setState({ validEmail: true });
            return false;
        }
        else {
            this.setState({ error: { isEmailId: true }, message: { isEmailId: '' } });
            this.setState({ validEmail: false });
        }
    };
    handlePassword = (event) => {
        this.setState({ password: event.target.value });
        let password = event.target.value;
        if (!password || password.length === 0) {
            this.setState({ error: { isPassword: true }, message: { isPassword: Constants.PLEASE_ENTER_PASSWORD } });
            this.setState({ validPassword: true });
            return false;
        }
        // else if (!isValidPassword(password)) {
        //     this.setState({ error: { isPassword: true }, message: { isPassword: Constants.PASSWORD_REG } })
        //     this.setState({ validPassword: true })
        //     return false;
        // }
        else {
            this.setState({ error: { isPassword: false }, message: { isPassword: '' } });
            this.setState({ validPassword: false });
        }
    };
    render() {
        const { email, password, empId, error, message, validEmail, validPassword, showPassword, requiresEmpId } = this.state;
        const { isLoading } = this.props.getLoginDetails;
        const Agent = this.props.match.path.split('/');
        const disableLogin = requiresEmpId ? !empId?.trim() : (validEmail || validPassword);
        return (
            <div className="proglint-meet">
                <div className="container">
                    <div className="row ">
                        <div className="d-flex justify-content-center  justify-content-md-end justify-content-lg-end mt-4">
                        </div>
                    </div>
                    <div className="row login-card-content">
                        <div className='d-flex align-items-center'>
                            <div className="d-none d-md-flex col-md-6 col-lg-6 login-left justify-content-center">
                                {
                                    Agent[1] === "vendor" ? <img src={require('../assets/img/vendor_login.png')} alt="login" width="60%" /> : Agent[1] === "admin" ? <img src={require('../assets/img/customer_care.png')} alt="login" width="40%" /> :
                                        <img src={require('../assets/img/customer.png')} alt="login" width="40%" />
                                }
                            </div>
                            <div className="col-md-6 col-lg-6 login-right">
                                <div className="px-5">
                                    <img src={loginLogo} className="logo-1 d-block mx-auto mb-2" alt="logo" width="15%" />
                                    <h2 className="login-head">{requiresEmpId ? Constants.EMPLOYEE_ID_STEP : Constants.LOGIN}</h2>
                                    {!requiresEmpId ? (
                                        <>
                                    <div className="col-12 login_inputBox mt-4">
                                        <input autoComplete="off" type="text" className="form-control input-box " placeholder={Constants.EMAIL_ID}
                                            aria-label="User name" value={email} onChange={(e) => this.handleEmail(e)} onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    this.submitHandler();
                                                }
                                            }} />
                                    </div>
                                    <div>
                                        {error.isEmailId && <h5 style={{ color: 'red', fontSize: '16px', marginTop: '10px' }}>{message.isEmailId}</h5>}
                                    </div>
                                    <div className="col-12 mt-4 input-group flex-nowrap mb-4 login_inputBox">
                                        <input autoComplete="off" type={showPassword ? 'text' : 'password'} className="form-control input-box" placeholder={Constants.PASSWORD}
                                            aria-label="Password" aria-describedby="view-pass" value={password} onChange={(e) => this.handlePassword(e)} onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    this.submitHandler();
                                                }
                                            }}></input>
                                        <button className="btn"
                                            onClick={() => this.setState({ showPassword: !showPassword })}
                                            type="button"
                                            id="view-pass">
                                        </button>
                                    </div>
                                    <div>
                                        {error.isPassword && <h5 style={{ color: 'red', fontSize: '16px', marginTop: '10px' }}>{message.isPassword}</h5>}
                                    </div>
                                        </>
                                    ) : (
                                        <>
                                    <div className="col-12 login_inputBox mt-4">
                                        <input autoComplete="off" type="text" className="form-control input-box" placeholder={Constants.ENTER_EMPLOYEE_ID}
                                            aria-label="Employee ID" value={empId} onChange={(e) => this.setState({ empId: e.target.value.replace(/\s/g, '') })} onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    this.submitHandler();
                                                }
                                            }} />
                                    </div>
                                    <div>
                                        {error.isEmpId && <h5 style={{ color: 'red', fontSize: '16px', marginTop: '10px' }}>{message.isEmpId}</h5>}
                                    </div>
                                    <div className="pt-2">
                                        <p className='m-0 forgetPassword' onClick={() => this.setState({ requiresEmpId: false, empId: '' })}>Back to hospital login</p>
                                    </div>
                                        </>
                                    )}
                                    {!requiresEmpId && (
                                    <div style={{ display: 'flex', justifyContent: 'end' }} className="pt-1">
                                        <p className='m-0 forgetPassword' onClick={() => this.forgetPassword()}>Forgot password</p>
                                    </div>
                                    )}
                                    <div className="col-12 text-center input-button">
                                        <button className="btn login-btn" type="button" disabled={disableLogin}
                                            onClick={() => this.submitHandler()}>{Constants.LOGIN}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {isLoading && <AppLoader />}
            </div>
        );
    }
}

export const mapStateToProps = (state) => {
    return {
        getLoginDetails: Actions.getLoginDetails(state)
    };
};
export default withRouter(connect(mapStateToProps, {
    login: Actions.loginAction,
    forgetpassword: Actions.forgetPassword
})(Login));